export default __webpack_public_path__ + "images/bd-d16830cba55e113c58881a5a7cb6a7cb.svg";